module.exports = __webpack_public_path__ + "static/media/login.c11962e4.jpeg";